import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import CookieConsent from "@/components/CookieConsent";

const PhishingSimulation = lazy(() => import("@/components/PhishingSimulation"));
const MaturityTest = lazy(() => import("@/components/MaturityTest"));
const StatsSection = lazy(() => import("@/components/StatsSection"));
const SolutionSection = lazy(() => import("@/components/SolutionSection"));
const RecognitionSection = lazy(() => import("@/components/RecognitionSection"));
const RegulationTimeline = lazy(() => import("@/components/RegulationTimeline"));
const CTASection = lazy(() => import("@/components/CTASection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <a
        href="#contenido-principal"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[200] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        Ir al contenido principal
      </a>
      <Header />
      <CookieConsent />
      <main id="contenido-principal">
        <HeroSection />
        <Suspense fallback={null}>
          <PhishingSimulation />
          <MaturityTest />
          <StatsSection />
          <SolutionSection />
          <RecognitionSection />
          <RegulationTimeline />
          <CTASection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
